import React from 'react'
import apiService from 'services/api'
import { filterStoreRepo } from '../../../../Filters/FilterStore'
import FilterModal from '../../../../Filters/components/FilterModal'
import { FilterIdentifier } from 'models/saved_view'
import { CommonFiltersetDoorsAccountGroup } from 'components/DataExpansionComponents/Common/CommonTable/CommonFiltersetDoorsAccountGroup'
import { CommonFiltersetGooglePlaceDoorGroup } from '../../GooglePlaceBase/GooglePlaceDoorBaseTable/CommonFiltersetGooglePlaceDoorGroup'
import { CONVENIENCE_DOORS_COLUMNS } from '../ConvenienceDoorsColumnsInfo'

export function ConvenienceDoorsFilterset({
  filterIdentifier,
  hideCampaignsFilter,
}: {
  filterIdentifier: FilterIdentifier
  hideCampaignsFilter?: boolean
}) {
  const api = apiService()
  const { data: campaignOptions } = api.useGetCampaignsOptions('convenience')

  const convenienceFilterStore = filterStoreRepo.getStore(filterIdentifier)
  const { data: convenienceCityStates } =
    api.useCommonGetCityStates('convenience')

  return (
    <FilterModal identifier={filterIdentifier} store={convenienceFilterStore}>
      <CommonFiltersetDoorsAccountGroup
        filterStore={convenienceFilterStore}
        campaignOptions={campaignOptions}
        hideCampaignsFilter={hideCampaignsFilter}
      />
      <CommonFiltersetGooglePlaceDoorGroup
        filterStore={convenienceFilterStore}
        columns={CONVENIENCE_DOORS_COLUMNS}
        allAvailableCities={convenienceCityStates}
      />
    </FilterModal>
  )
}
